export default function (Alpine) {
  Alpine.directive('h-switch', (el) => {
    // Additional component styles in 'src/styles/common.css'
    el.classList.add(
      '[&>input]:absolute',
      '[&>input]:appearance-none',
      '[&>input]:bg-transparent',
      '[&>input]:border-0',
      '[&>input]:cursor-pointer',
      '[&>input]:focus-visible:border-ring',
      '[&>input]:focus-visible:ring-[calc(var(--spacing)*0.75)]',
      '[&>input]:focus-visible:ring-ring/50',
      '[&>input]:left-0',
      '[&>input]:outline-none',
      '[&>input]:rounded-full',
      '[&>input]:size-full',
      '[&>input]:top-0',
      'before:bg-background',
      'before:duration-200',
      'before:block',
      'before:pointer-events-none',
      'before:ring-0',
      'before:rounded-full',
      'before:shadow-input',
      'before:h-full',
      'before:aspect-square',
      'before:transition-transform',
      'before:motion-reduce:transition-none',
      'bg-muted',
      'border',
      'data-[size=sm]:h-5',
      'data-[size=sm]:max-w-8',
      'data-[size=sm]:min-w-8',
      'duration-200',
      'h-6',
      'has-[input:checked]:before:translate-x-[calc(100%-var(--spacing))]',
      'has-[input:checked]:bg-primary',
      'has-[input:checked]:border-primary-active',
      'has-[input:disabled]:cursor-not-allowed',
      'has-[input:disabled]:opacity-disabled',
      'p-0.25',
      'max-w-10',
      'min-w-10',
      'relative',
      'rounded-full',
      'shrink-0',
      'transition-colors',
      'motion-reduce:transition-none'
    );
    if (el.tagName === 'SPAN') el.classList.add('inline-block');
    el.setAttribute('tabindex', '-1');
    el.setAttribute('data-slot', 'switch');
  });
}
